import { Typography, TextField } from "@material-ui/core";
import { useState } from "react";
import Autocomplete from "@material-ui/lab/Autocomplete";
import useProvinces from "../hooks/useProvinces";
import useDistricts from "../hooks/useDistrict";
import useSubDistricts from "../hooks/useSubDistricts";
import usePostcodes from "../hooks/usePostcodes";
import { useTranslate } from "react-admin";

const FullAddressInput = ({
  onChangeHandler,

  //   setProvince,
  //   setDistrict,
  //   setSubdistrict,
  //   setPostcode,
}) => {
  // const classes = useStyles();

  const [province, setProvince] = useState();
  const [district, setDistrict] = useState();
  const [subDistrict, setSubDistrict] = useState();
  const [postcode, setPostcode] = useState();

  const onProvinceChange = (data) => {
    setProvince(data);
    setDistrict();
    setSubDistrict();
    setPostcode();
    onChangeHandler(data, "province");
  };
  const onDistrictChange = (data) => {
    setDistrict(data);
    setSubDistrict();
    setPostcode();
    onChangeHandler(data, "district");
  };
  const onSubDistrictChange = (data) => {
    setSubDistrict(data);
    setPostcode();
    onChangeHandler(data, "subdistrict");
  };
  const onPostcodeChange = (data) => {
    setPostcode(data);
    onChangeHandler(data, "postcode");
  };

  return (
    <>
      <ProvinceInput province={province} setProvince={onProvinceChange} />

      <DistrictInput
        province={province}
        district={district}
        setDistrict={onDistrictChange}
      />
      <SubDistrictInput
        district={district}
        subDistrict={subDistrict}
        setSubDistrict={onSubDistrictChange}
      />

      <PostcodeInput
        subDistrict={subDistrict}
        setPostcode={onPostcodeChange}
        postcode={postcode}
      />
    </>
  );
};

const ProvinceInput = ({ province, setProvince }) => {
  const { provinces, loading, error } = useProvinces();
  const translate = useTranslate();
  if (loading) return null;
  if (error) return <Typography>Error {error}</Typography>;
  return (
    <Autocomplete
      disableClearable
      defaultValue={province ? province.name : ""}
      value={province ? province.name : ""}
      options={provinces}
      getOptionLabel={(option) => {
        if (option.name) return option.name;
        else return option;
      }}
      getOptionSelected={(option) => {
        if (option.name) return option.name;
        else return option;
      }}
      onChange={(_, newValue) => {
        setProvince(newValue);
      }}
      style={{ width: 140 }}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder={translate("ra.text.inputInformation.province")}
          variant="outlined"
        />
      )}
    />
  );
};

const DistrictInput = ({ province, district, setDistrict }) => {
  const { districts, loading, error } = useDistricts(province?.id);
  const translate = useTranslate();
  if (loading) return null;
  if (error) return <Typography>Error {error}</Typography>;
  return (
    <Autocomplete
      disableClearable
      disabled={!province}
      defaultValue={district ? district.name : ""}
      value={district ? district.name : ""}
      options={districts}
      getOptionLabel={(option) => {
        if (option.name) return option.name;
        else return option;
      }}
      getOptionSelected={(option) => {
        if (option.name) return option.name;
        else return option;
      }}
      onChange={(_, newValue) => {
        setDistrict(newValue);
      }}
      style={{ width: 140 }}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder={translate("ra.text.inputInformation.district")}
          variant="outlined"
        />
      )}
    />
  );
};

const SubDistrictInput = ({ district, subDistrict, setSubDistrict }) => {
  const { subDistricts, loading, error } = useSubDistricts(district?.id);
  const translate = useTranslate();
  if (loading) return null;
  if (error) return <Typography>Error {error}</Typography>;
  return (
    <Autocomplete
      disableClearable
      disabled={!district}
      defaultValue={subDistrict ? subDistrict.name : ""}
      value={subDistrict ? subDistrict.name : ""}
      options={subDistricts}
      getOptionLabel={(option) => {
        if (option.name) return option.name;
        else return option;
      }}
      getOptionSelected={(option) => {
        if (option.name) return option.name;
        else return option;
      }}
      onChange={(_, newValue) => {
        setSubDistrict(newValue);
      }}
      style={{ width: 140 }}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder={translate("ra.text.inputInformation.subDistrict")}
          variant="outlined"
        />
      )}
    />
  );
};

const PostcodeInput = ({ subDistrict, postcode, setPostcode }) => {
  const { postcodes, loading, error } = usePostcodes(subDistrict?.id);
  const translate = useTranslate();
  if (loading) return null;
  if (error) return <Typography>Error {error}</Typography>;
  return (
    <Autocomplete
      disableClearable
      disabled={!subDistrict}
      defaultValue={postcode ? postcode.code : ""}
      value={postcode ? postcode.code : ""}
      options={postcodes}
      getOptionLabel={(option) => {
        if (option.code) return option.code;
        else return option;
      }}
      getOptionSelected={(option) => {
        if (option.code) return option.code;
        else return option;
      }}
      onChange={(_, newValue) => {
        setPostcode(newValue);
      }}
      style={{ width: 140 }}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder={translate("ra.text.inputInformation.postcode")}
          variant="outlined"
        />
      )}
    />
  );
};

// const AutoCompleteTemplate = ({
//   options,
//   defaultValue,
//   value,
//   onChange,
//   placeholder = "placeholder",
// }) => {
//   useEffect(() => {}, []);

//   return (
//     <Autocomplete
//       defaultValue={defaultValue}
//       value={value}
//       options={options}
//       getOptionLabel={(option) => {
//         if (option.name) return option.name;
//         else return option;
//       }}
//       getOptionSelected={(option) => {
//         if (option.name) return option.name;
//         else return option;
//       }}
//       onChange={(_, newValue) => {
//         onChange(newValue);
//       }}
//       style={{ width: 140 }}
//       renderInput={(params) => (
//         <TextField {...params} placeholder={placeholder} variant="outlined" />
//       )}
//     />
//   );
// };

export default FullAddressInput;
